import { TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import { PessoaFisicaVisualizar, PessoaJuridicaVisualizar } from 'app/main/pessoa';
import React from 'react';

const DadosGeraisVisualizar = ({ registro }) => {
  const { pessoa } = registro;
  const { tipoPessoa } = pessoa;

  const exibirPessoaJuridica = tipoPessoa === 'JURIDICA';
  const exibirPessoaFisica = tipoPessoa === 'FISICA';

  const options = [
    { title: 'Jurídica', id: 'JURIDICA' },
    { title: 'Física', id: 'FISICA' },
  ];

  const tipoPessoaValue = tipoPessoa && options.find((op) => op.id === tipoPessoa).title;
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextLabel id="pessoa.nome" label="Nome" value={pessoa.nome} />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextLabel label="Tipo de pessoa" id="pessoa.tipoPessoa" value={tipoPessoaValue} />
      </Grid>

      {exibirPessoaJuridica && (
        <PessoaJuridicaVisualizar
          pessoaJuridica={pessoa.pessoaJuridica}
          inscricaoMunicipal={pessoa.inscricaoMunicipal}
        />
      )}
      {exibirPessoaFisica && (
        <PessoaFisicaVisualizar pessoaFisica={pessoa.pessoaFisica} inscricaoMunicipal={pessoa.inscricaoMunicipal} />
      )}
    </Grid>
  );
};

export default DadosGeraisVisualizar;
